import { defineRelations } from "@-/com.npmjs.drizzle-orm";
import * as contentSchema from "#schema";

export const contentRelations = defineRelations(contentSchema, (r) => ({
  appGraphemeMeaningCard: {
    aliases: r.many.appGraphemeMeaningCardAlias({
      from: r.appGraphemeMeaningCard.id,
      to: r.appGraphemeMeaningCardAlias.appGraphemeMeaningCardId,
    }),
    description: r.one.appGraphemeMeaningCardDescription({
      from: r.appGraphemeMeaningCard.id,
      to: r.appGraphemeMeaningCardDescription.appGraphemeMeaningCardId,
    }),
    // Both card tables key off the same `grapheme` text; the meaning card's
    // `grapheme` is unique, so this resolves to all pronunciation cards for the
    // same grapheme.
    pronunciationCards: r.many.appGraphemePronunciationCard({
      from: r.appGraphemeMeaningCard.grapheme,
      to: r.appGraphemePronunciationCard.grapheme,
    }),
  },
  appGraphemeMeaningCardAlias: {
    meaningCard: r.one.appGraphemeMeaningCard({
      from: r.appGraphemeMeaningCardAlias.appGraphemeMeaningCardId,
      optional: false,
      to: r.appGraphemeMeaningCard.id,
    }),
  },
  appGraphemeMeaningCardDescription: {
    meaningCard: r.one.appGraphemeMeaningCard({
      from: r.appGraphemeMeaningCardDescription.appGraphemeMeaningCardId,
      optional: false,
      to: r.appGraphemeMeaningCard.id,
    }),
  },
  appGraphemePronunciationCard: {
    meaningCard: r.one.appGraphemeMeaningCard({
      from: r.appGraphemePronunciationCard.grapheme,
      to: r.appGraphemeMeaningCard.grapheme,
    }),
  },
}));
